
export const MOBILE = (typeof window !== 'undefined') ? (window.screen.availWidth < 800) : true;
export const USE_MOCK_SERVICE: any = { CAN_MOCK: false };
export class ViewConstants {
  static ARROW_DOWN='tmi tmi-arrow-sm-dwn';
  static FRONT_END_GROSS="Front-End Gross";
  static BACK_END_GROSS="Back-End Gross";
  static ACCESSORYDISCOUNTS='Accessory Discounts';
  static INTEGRATE_SERVICE: boolean = true;
  static STOCK = 'STOCK #';
  static MODELNO = 'MODEL';
  static MODELDESCRIPTION = 'MODEL DESC';
  static EXTERIORCOLOR = 'EXT. COLOR';
  static EXTERIORCLR = 'EXT CLR';
  static INTERIORCOLOR = 'INT. COLOR';
  static INTERIORCLR = 'INT CLR';
  static CERTIFICATION_NUMBER = 'CERTIFICATION #';
  static MODELYEAR = 'YEAR';
  static CANCEL = 'CANCEL';
  static VIN = 'VIN';
  static ACCESSORIES = 'ACCESSORIES';
  static DIOINDICATOR = 'DIO IND';
  static CATEGORY = 'CAT';
  static DIS = 'DIS';
  static DAYS_ONLINE = 'DAYS ONLINE';
  static ORIGINAL_DEALER = 'ORIGINAL DEALER';
  static DEALER_INVOICE_PRICE = 'INVOICE($)';
  static MAAP = 'MAAP($)';
  static ADVERTIZED_PRICE = 'ADV PRICE($)';
  static SELLING_PRICE = 'EPRICE($)';
  static MSRP = 'MSRP($)';
  static CAMP = 'CAMP';
  static ONLINE = 'ONLINE';
  static HOLD_STATUS = 'HOLD';
  static RDR = 'RDR';
  static COMMENTS = 'COMMENTS';
  static COMMENT = 'COMMENT';
  static HOLD_COMMENTS = 'HOLD COMMENTS';
  static INCENTIVE = 'INCENTIVE';
  static ADD = 'ADD';
  static ITEMNO = 'ITEM NO.';
  static NAME = 'NAME';
  static SOURCE = 'SOURCE';
  static DEALER_INVOICE = 'DEALER INVOICE($)';
  static RETAIL_PRICE = 'RETAIL PRICE($)';
  static FULL_VIEW = 'Full View';
  static PART_NO = 'PART NUMBER';
  static MODELS = 'MODELS';
  static MODEL = 'MODEL';
  static DESCRIPTION = 'DESCRIPTION';
  static DIO_PRICE = 'DIO PRICE($)';
  static DEALER_FEE = 'Dealer Fee';
  static ADVERTISED_PRICE = 'ADVERTISED PRICE';
  static AMOUNT = 'AMOUNT';
  static ATTRIBUTE = 'ATTRIBUTE';
  static DEFAULT = 'DEFAULT';
  static DETAILS = 'DETAILS';
  static TYPE = 'TYPE';
  static VEHICLE = 'VEHICLE';
  static EDIT = 'EDIT';
  static DELETE = 'REMOVE';
  static DISCOUNT_ADV_PRICE = 'ADV DISCOUNT($)';
  static DISCOUNT_EPRICE = 'EPRICE DISCOUNT($)';
  static DISCOUNT_SELLING_PRICE = 'SELLING DISCOUNT($)';
  static APPLIED = 'APPLIED';
  static CUSTOMER_NAME = 'CUSTOMER';
  static STOCK_NUMBER = 'STOCK NUMBER';
  static VIN_NUMBER = 'VIN NUMBER';
  static DEAL_TYPE = 'TYPE';
  static STATUS = 'STATUS';
  static LAST_MODIFIED = 'LAST MODIFIED';
  static ASSOCIATE = 'ASSOCIATE';
  static USD = 'USD';
  static USD_SYMBOL = '$';
  static COMMA = ',';
  static EMPTY_STRING = '';
  static SELECT = 'Select';
  static SELECT_UPPERCASE = 'SELECT';
  static DD_ITSUPPORTADMIN = 'DD_ITSupportAdmin';
  static DD_RTIRETAILDELETEFEATURE = 'DD_RTIRetailDeleteFeature';
  static DD_OFFICESTAFFADMINISTRATION = 'DD_OfficeStaffAdministration';
  static DD_RTIEXPRESSPURCHASEROLE = 'DD_RTIExpressPurchaserole';
  static DD_NEWVEHICLEVMSINCLUDECOST = 'DD_NewVehicleVMSIncludeCost';
  static DD_NEWVEHICLEVMSEXCLUDECOST = 'DD_NewVehicleVMSExcludeCost';
  static DD_SIGNAL = 'DD_Signal';
  static SELECT_VIEW_HEADER = 'SELECT VIEW';
  static DELETE_VIEW_HEADER = 'DELETE';
  static DEFAULT_VIEW_HEADER = 'DEFAULT';
  static SAVE_BUTTON = 'SAVE';
  static CLOSE_ICON = 'close';
  static VEHICLE_DETAIL_SCREEN_NAME = 'Vehicle Details';
  static MANAGE_DIO_SCREEN_NAME = 'Manage DIO';
  static PRICING_PROMOTE_SCREEN_NAME = 'Pricing Promote';
  static GROUP_PRICING_SCREEN_NAME = 'Group Pricing';
  static DIO_ADMIN_SCREEN_NAME = 'DIO Administration';
  static DIO_ADMINDETAIL_SCREEN_NAME = 'DIO Administration ';
  static DIO_ADMIN_MENU_NAME = 'DIO Admin';
  static DEALER_FEES_SCREEN_NAME = 'Dealer Fees';
  static DISCLAIMERS_SCREEN_NAME = 'Disclaimers';
  static DEAL_UPDATE_SCREEN_NAME = 'WRITE-UP UPDATES';
  static DESCRIPTIONS_SCREEN_NAME = 'Descriptions';
  static VEHICLE_HOLD_SCREEN_NAME = 'Vehicle Holds';
  static CUSTOMER_DEALS_SCREEN_NAME = 'Customer/Write-ups';
  static MST_DEAL_DETAIL_SCREEN_NAME = 'MST: WRITE-UP DETAILS';
  static VEHICLE_HISTORY_SCREEN_NAME = 'Vehicle History';
  static TOY = 'TOY';
  static NATIONAL = 'NATIONAL';
  static YES_NO = 'YES-NO';
  static OK_CANCEL = 'OK-CANCEL';
  static PROMOTE = 'Promote';
  static EPRICE = 'ePrice';
  static ADVERTISEPRICE = 'Advertise Price';
  static F = 'F';
  static D = 'D';
  static P = 'P';
  static ALLOCATED = 'Allocated';
  static INTRANSIT = 'InTransit';
  static GROUND = 'Ground';
  static PROMOTED = 'Promoted';
  static OFFLINE = 'Off-Line';
  static ONHOLD = 'On Hold';
  static ASC = 'ASC';
  static DESC = 'DESC';
  static VEHICLE_DETAIL_ROUTING = '/vehicle/';
  static CLEAR_ALL = 'Clear All';
  static DEALER_CATEGORY_A = 'A';
  static DEALER_CATEGORY_F = 'F';
  static DEALER_CATEGORY_G = 'G';
  static DEALER_CATEGORY_GP = 'GP';
  static ONLINE_STATUS_Y = 'Y';
  static ONLINE_STATUS_N = 'N';
  static HOLD_STATUS_YES = 'Yes';
  static EXT_COLOR_FIELDNAME = 'extColor.colorCd';
  static INT_COLOR_FIELDNAME = 'intColor.colorCd';
  static FILTER_VALUE_INTRANSIT = 'I';
  static OPTION_TYPE_D = 'D';
  static SPACE = ' ';
  static SELECTED = 'selected';
  static DOT = '.';
  static GET_FILTER_ACTION_LOGGER = 'GetFilterAction Action Invoked. Parameter : None';
  static SAVE_SHOW_MODEL_LOGGER = 'SaveShowModelStateAction Action Invoked. Parameter : ';
  static SAVE_FILTER_ACTION_LOGGER = 'SaveFilterAction Action Invoked. Parameter : ';
  static SAVE_GRID_FILTER_LOGGER =
  'SaveGridFiltersStateAction Action Invoked. Parameter : ';
  static SAVE_CURRENT_VIEW_LOGGER =
  'SaveCurrentViewStateAction Action Invoked. Parameter : ';
  static SAVE_HEADER_CHECKBOX_LOGGER =
  'SaveHeaderCheckboxStateAction Action Invoked. Parameter : ';
  static DAYS_IN_STOCK = 'daysInStock';
  static DAYS_IN_STOCK_NUMERIC = 'daysInStockNumeric';
  static DAYS_ON_LINE = 'daysOnline';
  static PRICE_MAAP = 'price.maap';
  static PRICE_TOTAL_MSRP = 'price.totalMsrp';
  static PRICE_SELLING_PRICE = 'price.sellingPrice';
  static PRICE_ADVERTIZE_PRICE = 'price.advertizedPrice';
  static PRICE_TOTAL_DEALER_INVOICE = 'price.totalDealerInvoice';
  static PRICE_TOTAL_DIOS_VALUE = 'price.totalDiosValue';
  static PRICE_TOTAL_DEALER_FEE_VALUE = 'price.totalDealerfeeValue';
  static ADV_PRICE_DISCOUNT = 'advPriceDiscount';
  static EPRICE_DISCOUNT = 'ePriceDiscount';
  static MODEL_MODELCD = 'model.modelCd';
  static MODEL_PHASECD = 'model.phaseCd';
  static ACCESSORIES_LOWER_CASE = 'accessories';
  static IN_LIST = 'inlist';
  static NOT_IN_LIST = 'notinlist';
  static STARTS_WITH = 'startsWith';
  static INDEX_OF = 'indexOf';
  static ADD_COMMENTS_SERVICE_CALL_LOGGER = 'service call for add Comments';
  static ADD_COMMENTS_SERVICE_INVOKED_LOGGER = 'add  comments Service invoked - ';
  static GET_COMMENTS_SERVICE_METHOD_LOGGER = 'Get comments Service method.. ';
  static GET_COMMENTS_SERVICE_INVOKED_LOGGER = 'Get comments Service invoked - ';
  static AUTHORIZATION = 'Authorization';
  static ID_TOKEN = 'id-token';
  static USERS = 'users';
  static USER_NAME_DOUBLE_QUOTES = 'Username "';
  static IS_ALREADY_TAKEN = '" is already taken';
  static ROUTER_TRANSITION = 'routerTransition';
  static VOID = 'void';
  static FIXED = 'fixed';
  static HUNDRED_PERCENTAGE = '100%';
  static STAR = '*';
  static COLON_ENTER = ':enter';
  static TRANSLATE_X_HYPHEN_HUNDRED_PERCENTAGE = 'translateX(-100%)';
  static TRANSLATE_X_HUNDRED_PERCENTAGE = 'translateX(100%)';
  static TRANSLATE_Y_HYPHEN_HUNDRED_PERCENTAGE = 'translateY(-100%)';
  static TRANSLATE_Y_HUNDRED_PERCENTAGE = 'translateY(100%)';
  static ZERO_FIVE_S_EASE_IN_OUT = '0.5s ease-in-out';
  static ZERO_SIX_S_EASE_IN_OUT = '0.6s ease-in-out';
  static COLON_LEAVE = ':leave';
  static TRANSLATE_X_ZERO_PERCENTAGE = 'translateX(0%)';
  static TRANSLATE_Y_ZERO_PERCENTAGE = 'translateY(0%)';
  static NUMBER = 'number';
  static REQUIRED_PARAMETER_IS_NULL_OR_UNDEFINED =
  'Catastrophe!! Required parameter is null or undefined while invoking {ServiceName} Services. '
  + 'Parameter Name : {ParameterName}';
  static ERROR_LOG_SERVICE = 'Error Log Service';
  static HTTP_ERROR_WHILE_LOGGING_SERVER = 'Http error while logging to server: ';
  static ERROR_HANDLER = 'ErrorHandler';
  static ERROR_WHEN_TRYING_OUTPUT_ERROR = 'Error when trying to output error.';
  static ERROR_WHEN_TRYING_TO_LOG_ERROR = 'Error when trying to log error to';
  static CONTENT_TYPE = 'Content-Type';
  static APPLICATION_JSON = 'application/json';
  static ACCEPT = 'Accept';
  static AUTHORIZATION_LOWER_CASE = 'authorization';
  static BEARER = 'Bearer ';
  static ID_TOKEN_HTTP_CLIENT = 'id_token';
  static ACCESS_TOKEN_HTTP_CLIENT = 'access_token';
  static RTI = 'rti';
  static GARAGE = '/garage/';
  static MENU = 'menu';
  static SIDENAV_NAME_REGISTERED_ALREADY = 'Sidenav already registered with that name';
  static ICON_VEHICLE_DETAIL = 'Icon-Vehicle-Detail';
  static ICON_DIOS = 'Icon-DIOs';
  static ICON_PRICING_PROMOTE = 'Icon-Pricing-Promote';
  static ICON_HOLD_MANAGEMENT = 'Icon-Hold-Management';
  static ICON_VEHICLE_HISTORY = 'Icon-Vehicle-History';
  static EDIT_DISCLAIMER_LOGGER = 'EditDisclaimerAction action invoked. Parameter : ';
  static DELETE_DISCLAIMER_LOGGER = 'DeleteDisclaimerAction action invoked. Parameter : ';
  static ADD_DISCLAIMER_LOGGER = 'AddDisclaimerAction action invoked. Parameter : ';
  static GET_DISCLAIMER_LOGGER = 'GetDisclaimersAction action invoked. Parameter : ';
  static GET_DISCLAIMER_TYPE_LOGGER =
  'GetDisclaimerTypesAction action invoked. Parameter : null';
  static SET_DIO_FIO_LOGGER = 'SetDioAndFIO Action Invoked. Parameter: dataFormatter';
  static INITIAL_LOAD_LOGGER =
  'InitialLoadAction Action Invoked. Parameter: ';
  static SEMICOLON_SPACE = '; ';
  static DEALERCD = 'dealerCd';
  static COLON_SPACE = ': ';
  static MARKETINGSERIES = 'marketingSeries';
  static GET_DIO_FOR_VIN_LOGGER = 'GetDIODetailsForVINAction Action Invoked. Parameter: ';
  static APPLY_DIO_CHANGES_LOGGER = 'ApplyDIOChangesAction Action Invoked. Parameter: ';
  static GET_INDIVIDUAL_DIO_LOGGER =
  'GetIndividualDIODataAction Action Invoked. Parameter: ';
  static GET_PROMOTE_DESCRIPTION_LOGGER =
  'GetPromoteDescriptionAction Action Invoked. Parameter : ';
  static DESCRIPTION_SAVE_LOGGER = 'DescriptionsSaveAction Action Invoked. Parameter : ';
  static FILE_DOWNLOAD_ICON = 'file_download';
  static PRINT_ICON = 'print';
  static HELP_ICON = 'help';
  static ACTIVATE_EVENT = 'Activate Event:';
  static DE_ACTIVATE_EVENT = 'Deactivate Event';
  static DEVELOPMENT = 'development';
  static INSIDE_AUTH_REDUCER_LOG = 'inside auth reducer - ';
  static AUTH_USER_SET_LOG = 'Auth user set - ';
  static DELETE_DISCLAIMER_FAIL_MESSAGE =
  '409 - OK Conflict';
  static HOLD_COMMENTS_USER_VIEW = 'holdComments';
  static INCENTIVE_LOWER_CASE = 'incentive';
  static DEALER_CATEGORY = 'dealerCategory';
  static ONLINE_STATUS = 'Online';
  static CUSTOMER_HOLD = 'Customer Hold';
  static YES = 'Yes';
  static NO = 'No';
  static NA = 'NA';
  static TOYOTA = 'TOYOTA';
  static LEXUS = 'LEXUS';
  static AFTER_MARKET = 'AFTER MARKET';
  static UNDEFINED_UPPER_CASE = 'UNDEFINED';
  static NULL_UPPER_CASE = 'NULL';
  static SOURCE_TYPE = 'SOURCE_TYPE';
  static SEARCH_TEXT = 'SEARCH_TEXT';
  static DECIMAL_AD_PRICE = 'decimalAdvPrice';
  static DECIMAL_EPRICE = 'decimalEPrice';
  static ADVPRICE = 'ADVPRICE';
  static ERROR_FIELD = 'errorField';
  static MANDATORY_ERROR_FIELD = 'mandatoryErrorField';
  static CURRENT_OPERATION_OFFLINE = 'OFFLINE';
  static CUSTOM = 'CUSTOM';
  static HYPHEN = '-';
  static VIN_WITH_CURLY = '{vins}';
  static MSRP_DIO = 'MSRP + DIO';
  static INVOICE_DIO = 'INVOICE + DIO';
  static INVOICE_RULE = 'INVOICE';
  static MSRP_RULE = 'MSRP';
  static DEALER_INVOICE_RULE = 'DEALER INVOICE';
  static RETAIL_PRICE_RULE = 'RETAIL PRICE';
  static PROMOTE_VEHICLE_LOGGER = 'PromoteVehicleAction Action Invoked. Parameter: ';
  static OFFLINE_VEHICLE_LOGGER = 'OfflineVehicleAction Action Invoked. Parameter: ';
  static INITIAL_LOAD_LOGGER_NULL = 'InitialLoadAction Action Invoked. Parameter: null';
  static VEHICLE_PRICING_ROUTING = '/pricing/';
  static SAVE_VEHICLE_LOGGER = 'SaveVehicleAction Action Invoked. Parameter: ';
  static DIO_EDIT_ACCESSORY_LOGGER =
  'DIOAdminDetailEditAccessory action invoked. Parameter: ';
  static DIO_ADD_ACCESSORY_LOGGER =
  'DIOAdminDetailCreateNewAccessory action invoked. Parameter: ';
  static DIO_ADMIN_LIST_ROUTING = '/dioadminlist';
  static DIO_ADMIN_DETAIL_LOAD_DIO_LOGGER =
  'DIOAdminDetailLoadDIOData action invoked. Parameter: ';
  static PART_NUMBER = 'partNumber';
  static DIO_ADMIN_DETAIL_INITIAL_LOAD =
  'DIOAdminDetailNewAccessoryInitialLoad action invoked. Parameter: None';
  static EFC_DATA_LOAD_LOGGER =
  'EFCDataLoadAction action invoked. Parameter: brand : TOY ; regionName : NATIONAL';
  static ADD_SLIDES = 'slides - ';
  static M = 'M';
  static PERCENTAGE_SYMBOL = '%';
  static SAVE_PRICING_LOGGER = 'save clicked!';
  static CANCEL_PRICING_LOGGER = 'Cancel clicked!';
  static OPEN_DEALER_FEE_POPUP = 'OpenDealerFeePopup emitted!';
  static TERMS_ACCEPTED_LOGGER = 'terms accepted';
  static APPLY = 'APPLY';
  static RESET = 'RESET';
  static OFFLINE_CAMEL_CASE = 'Offline';
  static DEFAULT_PROMOTE_DESCRIPTION_LOGGER =
  'GetDefaultPromoteDescriptionAction Action Invoked. Parameter: ';
  static DEFAULT_PROMOTE_DISCLAIMER_LOGGER =
  'GetDefaultPromoteDisclaimerAction Action Invoked. Parameter: ';
  static SAVE_OFFLINE_ACTION_LOGGER = 'SaveOffline Action Invoked. Parameter: ';
  static SAVE_PROMOTE_ACTION_LOGGER = 'SavePromote Action Invoked. Parameter: ';
  static CONTAINER_CALLED_LOGGER = 'container called!';
  static DIALOG_SERVICE_MESSAGE =
  'The changes will be pushed to market place. Do you want to continue?';
  static OK = 'OK';
  static SAVE_PRICING_PROMOTE_LOGER =
  'SavePricingPromote Action Invoked. Parameter:invokeSavePromote:false; invokeSaveOffline:true';
  static PREVIEW_VEHICLE = 'PREVIEW VEHICLE';
  static PROMOTE_CONTAINER_LOGGER = 'promote container called!';
  static TAKE_OFFLINE_LOGGER = 'takeOffline container called!';
  static OPEN_DEALER_FEE_POPUP_LOGGER = 'openDealerFeePopup invoked in container';
  static UPDATE_ADV_PRICE_LOGGER = 'UpdateAdPriceAction Action Invoked. Parameter:';
  static UPDATE_SELLING_PRICE_LOGGER =
  'UpdateSellingPriceAction Action Invoked. Parameter:';
  static CANCE_CHANGES_LOGGER = 'cancel changes: ';
  static PROMOTE_DESCRIPTION = 'Promotion Description';
  static UPDATE_PROMOTE_DESCRIPTION_LOGGER =
  'promoteDescriptionText action invoked. Parameter : ';
  static PROMOTE_SAVING_LOGGER =
  'SavePricingPromote Action Invoked. Parameter: vehicle: invokeSavePromote: true ;' +
  'invokeSaveOffline: false ;invokeSaveOfflineByClickingSaveButton: false';
  static TAKE_OFFLINE_SAVE_LOGGER =
  'SavePricingPromote Action Invoked. Parameter: vehicle: invokeSavePromote: false ;' +
  'invokeSaveOffline: true ; invokeSaveOfflineByClickingSaveButton: false';
  static VEHICLE_SERVICE_VIN_METHOD_LOGGER =
  'Executing Get Vehicle By VIN method';
  static GET_VEHICLES_BY_VIN_MOCKMETHOD_LOGGER =
  'Search Vehicles details static data invoked - ';
  static GET_VEHICLES_BY_VIN_SERVICE_LOGGER =
  'Get Vehicle By VIN Service invoked - ';
  static VEHICLES_RESPONSE_RECEIVED_LOGGER =
  'vehicles object response received ';
  static GET_VEHICLES_VIN_ARRAY_METHOD_LOGGER =
  'Executing Get Vehicle By VIN Array method : ';
  static GET_VEHICLES_VIN_ARRAY_STATIC_METHOD_LOGGER =
  'Executing Get static Vehicle By VIN method : ';
  static RESIDUAL_SERVICE_METHOD_LOGGER = 'Enter Residual Service Method';
  static RESIDUAL_MOCK_SERVICE_LOGGER = 'Enter Residual mock service method';
  static RESIDUAL_RESOPONSE_RECEIVED_LOGGER = 'residual object response received ';
  static EXECUTING_SEARCH_VEHICLES_LOGGER = 'Executing Search Vehicles method';
  static SEARCH_VEHICLE_SERVICE_LOGGER = 'Search Vehicles Service invoked - ';
  static SEARCH_VEHICLE_STATIC_DATA_LOGGER = 'Search Vehicles static data invoked - ';
  static GET_DIO_LOGGER = 'Executing Get DIO Master List method';
  static GET_DIO_MASTER_LIST_LOGGER = 'Get DIO Master List Service invoked - ';
  static DIO_OBJECT_RESPONSE_LOGGER = 'Dios object response received ';
  static GET_ASSOCIATED_DIO_LOGGER = 'Executing Get Associated DIO List method';
  static GET_ASSOCIATED_DIO_SERVICE_LOGGER = 'Get Associated DIO List Service invoked - ';
  static GET_ASSOCIATED_DIO_RESPONSE_LOGGER =
  'Dios of the selected Vehicle object response received ';
  static EXECUTING_UPDATE_DIO_LOGGER = 'Executing Update DIO method';
  static UPDATE_DIO_SERVICE_LOGGER = 'Update DIO Service invoked - ';
  static EXECUTING_LOAD_DIO_LOGGER = 'Executing Load DIO method';
  static LOAD_DIO_SERVICE_LOGGER = 'Load DIO Service invoked -';
  static EXECUTING_DELETE_VIEW_LOGGER = ' Executing delete view method';
  static DELETE_VIEW_LOGGER = 'Delete View Service Invoked - ';
  static EXECUTING_UPDATE_VIEW_LOGGER = ' Executing update view method';
  static UPDATE_VIEW_LOGGER = 'Update View Service Invoked - ';
  static EXECUTING_DEFAULT_VIEW_LOGGER = ' Executing update default view method';
  static UPDATE_DEFAULT_VIEW_LOGGER = 'Update Default View Service Invoked - ';
  static EXECUTING_SAVE_VIEW_LOGGER = ' Executing save view method';
  static SAVE_VIEW_LOGGER = 'Save View Service Invoked - ';
  static EXECUTING_GET_VIEW_LOGGER = ' Executing get user view method';
  static GET_USER_VIEW_LOGGER = 'Get User View Service Invoked - ';
  static EXECUTING_GET_PREDEFINED_VIEW_LOGGER = ' Executing get predefined view method';
  static GET_PREDEFINED_VIEW_LOGGER = 'Get Predefined View Service Invoked - ';
  static EXECUTING_SAVE_DESCRIPTION_LOGGER =
  'Executing save Description Service method..';
  static GET_PROMOTE_DESC_SERVICE_LOGGER = 'get promote description Service invoked - ';
  static GET_PROMOTE_DESC_LOGGER = 'service call for get promote description details - ';
  static EXECUTING_GET_PROMOTE_DESC_LOGGER =
  ' Executing get Promote details Service method.. ';
  static SAVE_PROMOTE_DESC_LOGGER = 'Save  Promote description Service invoked - ';
  static SAVE_PROMOTE_LOGGER = 'service call for save promote - ';
  static EXECUTING_CREATE_DIO_LOGGER = 'Executing Create New DIO method';
  static CREATE_NEW_DIO_SERVICE_LOGGER = 'Create New DIO Service invoked - ';
  static EXECUTING_EDIT_DIO_LOGGER = 'Executing Edit Existing DIO method';
  static EDIT_DIO_SERVICE_LOGGER = 'Edit Existing DIO Service invoked - ';
  static DEALER_SUB_CATEGORY_G_STAR = 'G*';
  static RESERVE = 'RESERVE';
  static AVAILABLE = 'AVAILABLE';
  static DEALER_SUB_CATEGORY = 'dealerSubCategory';
  static RDR_STATUS = 'rdrStatus';
  static CUST_NAME = 'custName';
  static TOOLTIP_BREAK = '\n';
  static TOOLTIP_MESSAGE_HYPHEN = '-';
  static NEW_INTERFACE = 'NEWINTERFACE';
  static QUEUED = 'QUEUED';
  static PENDING = 'PENDING';
  static RECEIPT = 'Receipt';
  static DEALER_HOLD = 'DEALERHOLD';
  static HTML_BREAK = '<br />';
  static HTML_UL_OPEN = '<ul>';
  static HTML_UL_CLOSE = '</ul>';
  static HTML_LI_OPEN = '<li>';
  static HTML_LI_CLOSE = '</li>';
  static VISITED_STATUS = 'READ';
  static HIDE_SHOW = 'HIDE/SHOW';
  static DRAFT = 'draft';
  static PUBLISHED = 'published';
  static DIO_FAILURE_REASON = 'partVehicleAssignedCanNotModifyError';
  static DEAL_TYPE_FINANCE = 'finance';
  static DEAL_TYPE_TRADE_FINANCE = 'trade - finance';
  static DEAL_TYPE_CASH = 'cash';
  static DEAL_TYPE_TRADE_CASH = 'trade - cash';
  static DEAL_TYPE_LEASE = 'lease';
  static DEAL_TYPE_TRADE_LEASE = 'trade - lease';
  static ONE_PAY_LEASE = '1_pay_lease';
  static SIGN_AND_DRIVE_LEASE = 'sign_and_drive_lease';
  static REGULAR_LEASE = 'regular_lease';
  static DEAL_TYPE_TRADE = 'trade';
  static DEAL_TYPE_RETAIL = 'retail';
  static DEAL_STATUS_APPROVED = 'approved';
  static EXPIRED_MST = 'Expired';
  static CANCELLED_MST = 'Cancelled';
  static DFI_SUBMITTED = 'DFI Submitted';
  static DEAL_STATUS_CUSTOMER_ACCEPTED = 'finalized';
  static ONLINE_STATUS_READY_FOR_DEALER = 'Ready for Dealer';
  static ROLE_SALES_PERSON = 'Sales Person';
  static ROLE_SALES_MANAGER = 'Sales Manager';
  static VISIBLE = 'VISIBLE';
  static LAST_MODIFIED_DATE = 'LAST MODIFIED DATE';
  static Y = 'Y';
  static N = 'N';
  static ERROR_404 = '404';
  static ADD_DIO_IMAGE = 'Add DIO Image';
  static EDIT_DIO_IMAGE = 'Edit DIO Image';
  static ERROR_FETCHING_DISCLAIMERS = 'Error in fetching disclaimers';
  static CREDIT_RANGE = 'Credit Range';
  static TRADE_IN = 'TRADE - IN';
  static TRADEIN = 'TRADEIN';
  static ACCESSORIES_SENTENCE_CASE = 'Accessories';
  static SELECT_DIO_SCREEN_NAME = 'SELECT DIO';
  static QA = 'qa';
  static RTI_DASHBOARD = 'RTI DASHBOARD';
  static EXECUTING_UPLOAD_DIO_IMAGE_LOGGER = 'Executing upload image method';
  static UPLOAD_DIO_IMAGE_SERVICE_LOGGER = 'Upload Image Service invoked - ';
  static INCENTIVES_REBATES = 'Incentives & Rebates';
  static MILITARY = 'Military';
  static COLLEGE_STUDENT = 'College/Student';
  static LOYALTY = 'Loyalty';
  static VEHICLE_PRICE_CHANGED_EVENT = 'vehicle-dealer-price-changed-event';
  static VEHICLE_ADVPRICE_CHANGED_EVENT = 'vehicle-advprice-changed-event';
  static VEHICLE_EPRICE_CHANGED_EVENT = 'vehicle-eprice-changed-event';
  static VEHICLE_DIO_UPDATED_EVENT = 'vehicle-dio-changed-event';
  static VEHICLE_PROMOTED_EVENT = 'vehicle-promoted-event';
  static VEHICLE_OFFLINE_EVENT = 'vehicle-offlined-events';
  static OFFLINED_EVENT = 'vehicle-offlined-event';
  static EXECUTING_GET_DEALER_FEATURES = 'Executing get dealer features method';
  static GET_DEALER_FEATURE_SERVICE_LOGGER = 'Get Dealer Feature Service Invoked - ';
  static LOCAL_TAXES_FEES = 'Local Taxes & Fees Details';
  static VEHICLE_ON_GROUND_EVENT = 'vehicle-on-ground-event';
  static VEHICLE_RDR_INITIATED_EVENT = 'vehicle-rdr-initiated-event';
  static VEHICLE_RDR_CANCELLED_EVENT = 'vehicle-rdr-cancelled-event';
  static VEHICLE_RETURN_TO_STOCK_EVENT = 'vehicle-return-to-stock-event';
  static VEHICLE_RESERVED_EVENT = 'vehicle-reserved-event';
  static VEHICLE_UNRESERVED_EVENT = 'vehicle-unreserved-event';
  static VEHICLE_COMMENTS_UPDATED_EVENT = 'vehicle-comments-updated-event';
  static VEHICLE_TRADED_EVENT = 'vehicle-traded-event';
  static VEHICLE_SSC_OPEND_EVENT = 'vehicle-ssc-opened-event';
  static VEHICLE_SSC_CLOSED_EVENT = 'vehicle-ssc-closed-event';
  static VEHICLE_STOCK_NO_UPDATED_EVENT = 'vehicle-stock-no-updated-event';
  static VEHICLE_STOPSALE_CODE_CHANGED_EVENT = 'vehicle-stopsale-code-changed-event';
  static VEHICLE_FLEET_INDICATOR_CHANGED_EVENT = 'vehicle-fleet-indicator-changed-event';
  static VEHICLE_DEMO_CODE_EVENT = 'vehicle-demo-event';
  static RETAIL_PRICE_LABEL = 'Retail Price';
  static DEALER_PRICE_ADJUSTMENT = 'Dealer Price Adjustment';
  static OPTIONAL_ACCESSORIES = 'Optional Accessories';
  static ESTIMATED_TAXES_AND_FEES = 'Estimated Taxes & Fees';
  static DEALER_INVOICE_PRICE_LABEL = 'Dealer Invoice Price';
  static VEHICLE_ADDED_TO_STOCK = 'Vehicle added to stock';
  static RDR_INITIATED = 'RDR initiated';
  static RDR_CANCELLED = 'RDR cancelled';
  static RETURNED_TO_STOCK = 'Returned to stock';
  static VEHICLE_RESERVED = 'Vehicle Reserved';
  static VEHICLED_TRADED_IN = 'Vehicled traded in';
  static STOCK_NUMBER_UPDATED = 'Stock number updated';
  static VEHICLE_MADE_STOP_SALE = 'Vehicle made stop sale';
  static FLEET_INDICATOR_TURNED_ON = 'Fleet indicator turned on';
  static VEHICLE_MARKED_FOR_DEMO = 'Vehicle marked for demo';
  static NO_DATA_AVAILABLE = 'No Information available at this moment';
  static PENDING_APPROVAL = 'pending review';
  static DEAL_PRICIED = 'write-up priced';
  static VIEWS = 'VIEWS';
  static SAVES = 'SAVES';
  static LEADS = 'LEADS';
  static WRITEUPS = 'writeups';
  static BY_CUSTOMER = 'by customer';
  static LEAD_VIEW = 'Lead View';
  static SALES_AGENT_NAME = 'Sales Agent';
  static DEAL_SUBMITTED_TIME = ' Time';
  static DIO_DELETE_IMAGE = 'DELETE';
  static NAME_CAMEL_CASE = 'Name';
  static PART_NUMBER_CAMEL_CASE = 'Part Number';
  static ANONYMOUS = 'Anonymous';
  static ERROR_MESSAGE_UPLOAD_VALID_IMAGE_FILE = 'Upload valid image file';
  static MST_PROTECTIONS = 'Protection Product Admin';
  static PLANS = 'PLANS';
  static RECOMMENDED = 'RECOMMENDED';
  static DEFAULT_SELECTION = 'DEFAULT SELECTION';
  static TYPE_PLAN = 'TYPE/PLAN';
  static TERMS = 'TERMS';
  static RATES = 'RATES';
  static CASH_DOWN = 'Cash Down';
  static DEDUCTABLE = ' Deductable';
  static LOAD_DEAL_DETAILS_IMAGE_SERVICE_LOGGER =
  'Load deal details Image Service invoked -';
  static GRID = 'GRID';
  static MISSING_PRICE = 'Missing Price';
  static ALL_CATEGORY = 'All Category';
  static FRONTVIEW = 'Front View';
  static DRIVERSIDE = 'Driver Side';
  static PASSENGERSIDE = 'Passenger Side';
  static REARVIEW = 'Rear View';
  static ADDITIONALPHOTES = 'Additional Photos';
  static MST_OFFER = 'MST Offer';
  static MST_LEAD = 'MST Lead';
  static DIGITAL_GARAGE_LEAD = 'Digital Garage Lead';
  static OFFER = 'Offer';
  static DEALER_CONTACT = 'Dealer Contact';
  static TEST_DRIVE = 'Test Drive';
  static PAYMENT_ESTIMATOR = 'Payment Estimator';
  static MST_LEAD_DETAIL_SCREEN_NAME = 'MST: LEAD DETAILS';
  static MST_CUSTOMER_ACTIVITY_SCREEN_NAME = 'MST: CUSTOMER ACTIVITY';
  static MISSING_DISCLAIMER = 'Missing Disclaimer';
  static ROUTE_DASHBOARD = 'dashboard';
  static FEATURE_DASHBOARD = 'RTI-DASHBOARD';
  static ROUTE_VEHICLE = 'vehicle';
  static FEATURE_VEHICLE = 'RTI-VEHICLEDETAIL';
  static ROUTE_MANAGEDIO = 'vehicle-dio';
  static FEATURE_MANAGEDIO = 'RTI-MANAGEDIO';
  static ROUTE_PRICINGPROMOTE = 'pricing';
  static FEATURE_PRICINGPROMOTE = 'RTI-PRICINGPROMOTE';
  static ROUTE_GROUPPRICING = 'grouppricing';
  static FEATURE_GROUPPRICING = 'RTI-GROUPPRICING';
  static ROUTE_VEHICLEHISTORY = 'vehicle-history';
  static FEATURE_VEHICLEHISTORY = 'RTI-VEHICLEHISTORY';
  static ROUTE_DIOADMINSUMMARY = 'dioadminlist';
  static FEATURE_DIOADMINSUMMARY = 'RTI-DIOADMINSUMMARY';
  static ROUTE_DIOADMINDETAIL = 'dioAdminDetail';
  static FEATURE_DIOADMINDETAIL = 'RTI-DIOADMINDETAIL';
  static ROUTE_DISCLAIMERADMIN = 'disclaimers';
  static FEATURE_DISCLAIMERADMIN = 'RTI-DISCLAIMERADMIN';
  static FEATURE_DIOADMINLIST_EDIT_RETAILPRICE_VISISBLE = 'RTI-DIOADMINLIST-EDIT-RETAILPRICE-VISISBLE';
  static ROUTE_DESCRIPTIONADMIN = 'descriptions';
  static FEATURE_DESCRIPTIONADMIN = 'RTI-DESCRIPTIONADMIN';
  static ROUTE_FEATURE_WRITEUPSLEADS = 'wl';
  static ROUTE_CUSTOMERDEALSUMMARY = 'summary';
  static FEATURE_WRITEUPSLEADS = 'RTI-WRITEUPSLEADS';
  static ROUTE_FEATURE_CUSTOMERSUMMARY = 'cs';
  static ROUTE_CUSTOMERSUMMARY = 'customer-summary';
  static FEATURE_CUSTOMERSUMMARY = 'RTI-CUSTOMERSUMMARY';
  static ROUTE_FEATURE_WRITEUPDETAILS = 'wd';
  static ROUTE_WRITEUPDETAILS = 'writeup-detail';
  static FEATURE_WRITEUPDETAILS = 'RTI-WRITEUPDETAILS';
  static ROUTE_FEATURE_FIADMIN = 'fi';
  static ROUTE_FIADMIN = 'admin';
  static FEATURE_FIADMIN = 'RTI-FIADMIN';
  static ROUTE_FEATURE_CUSTOMERVIEW = 'cv';
  static ROUTE_CUSTOMERVIEW = 'customer-view';
  static FEATURE_CUSTOMERVIEW = 'RTI-CUSTOMERVIEW';
  static FEATURE_CUSTOMERDEALSUMMARY = 'RTI-CUSTOMERDEALSUMMARY';
  static ROUTE_CUSTOMERDEALDETAIL = 'deal-detail';
  static ROUTE_CUSTOMERDEALALERT = 'deal-alert';
  static FEATURE_CUSTOMERDEALDETAIL = 'RTI-CUSTOMERDEALDETAIL';
  static ROUTE_CUSTOMERLEADDETAIL = 'lead-detail';
  static ROUTE_CUSTOMERACTIVITYDETAIL = 'customer-activity';
  static FEATURE_CUSTOMERLEADDETAIL = 'RTI-CUSTOMERLEADDETAIL';
  static FEATURE_CUSTOMERACTIVITYDETAIL = 'RTI-CUSTOMERACTIVITYDETAIL';
  static ROUTE_DEALNOTIFICATION = 'deal-notification';
  static FEATURE_DEALNOTIFICATION = 'RTI-DEALNOTIFICATION';
  static ROUTE_VEHICLEHOLD = 'vehicle-hold';
  static FEATURE_VEHICLEHOLD = 'RTI-VEHICLEHOLD';
  static ROUTE_DEALERCONFIGURATION = 'dealer-configuration';
  static FEATURE_DEALERCONFIGURATION = 'RTI-DEALERCONFIGURATION';
  static PRODUCTION = 'production';
  static TEST = 'test';
  static STAGE = 'stage';
  static E2E = 'e2e';
  static DEALER_HOLD_CAMELCASE = 'DealerHold';
  static AVAILABLE_CAMELCASE = 'Available';
  static ADVERTISED_PRICE_AGE = 'advprice';
  static EPRICE_AGE = 'eprice';
  static DEAL_STATE = 'finalize';
  static CAP_NON_CAP_COSTS = 'REVIEW CAPITALIZED COSTS';
  static AUDIT = 'AUDIT'
  static PRICE_AGE = 'Price Not Changed';
  static ADV_PRICE_AGEING_7 = 'adv_price_ageing_7';
  static ADV_PRICE_AGEING_14 = 'adv_price_ageing_14';
  static ADV_PRICE_AGEING_30 = 'adv_price_ageing_30';
  static EPRICE_AGEING_7 = 'eprice_ageing_7';
  static EPRICE_AGEING_14 = 'eprice_ageing_14';
  static EPRICE_AGEING_30 = 'eprice_ageing_30';
  static TRADE_IN_PRICE_CHANGES = ' You have unsaved changes, the system will'
  + ' save these changes before proceeding';
  static ADVERTISED_DISCLAIMER_MISSING = `Advertise Price type disclaimers
   are mandatory if Advertised price is set`;
  static EPRICE_DISCLAIMER_MISSING = `Selling Price type disclaimers
   are mandatory if Selling Price is set`;
  static ADVERTISED_EPRICE_DISCLAIMER_MISSING = `Advertise Price and Selling Price type disclaimers
   are mandatory if Advertised price and Selling Price are set`;
  static PENDING_TRADE = 'Pending';
  static TRADE_IN_CLOSE = 'You have at least one trade in pending evaluation';
  static TRADE_IN_VALUE_MESSAGE='Please confirm trade-in valuation before approving the write-up.'
  static PENDING_APPROVAL_MST = 'Pending Review';
  static TRADE_APPROVED_MST = 'Trade Approved';
  static CUSTOMER_ACCEPTED = "CUSTOMER ACCEPTED";
  static APPROVED_MST = 'Dealer Approved';
  static INITIATED = 'Initiated';
  static NOT_VISITED_MST = 'NotVisited';
  static NOT_VISITED_DG = 'NotVisited_DG';
  static DEALER_PRICING_PROCESSOR = 'dealer-pricing-processor';
  static DEALER_CONFIG_SCREEN = 'Dealer Configuration';
  static FEATURE = 'feature';
  static ACTIVE = 'ACTIVE';
  static DEALER_VALUE = 'DEALER VALUE';
  static DEALER_VALUE_PRICED_AT = 'DEALER VALUE PRICED AT';
  static ADD_FEATURE = 'ADD FEATURE';
  static ACTIVITY_ATTRIBUTE = 'ACTIVITY / ATTRIBUTE';
  static EDITABLE = 'EDITABLE';
  static DATATYPE = 'DATA TYPE';
  static EVENT_TYPE_SYSTEM = 'UI';
  static DEFAULT_VALUE = 'DEFAULT VALUE';
  static SOURCE_SYSTEM = 'SOURCE SYSTEM';
  static DEAL_TRANSACTION_ID = 'DEAL TRANSACTION ID';
  static CUSTOMER_MST_ID = 'CUSTOMER MST ID';
  static CUSTOMER_UNIQUE_ID = 'CUSTOMER UNIQUE ID';
  static CREATION_DATE = 'CREATION DATE';
  static DEAL_EXPIRY_DATE = 'DEAL EXPIRY DATE';
  static DEAL_VISITED_STATUS = 'DEAL VISITED STATUS';
  static DEAL_VISITED_BY = 'DEAL VISITED BY';
  static DEAL_LAST_VISITED_DATE = 'DEAL LAST VISITED DATE';
  static CUSTOMER_EMAIL = 'CUSTOMER EMAIL';
  static CUSTOMER_PHONE_NUMBER = 'CUSTOMER PHONE NUMBER';
  static CUSTOMER_STREET = 'CUSTOMER STREET';
  static CUSTOMER_CITY = 'CUSTOMER CITY';
  static CUSTOMER_STATE = 'CUSTOMER STATE';
  static CUSTOMER_ZIPCODE = 'CUSTOMER ZIPCODE';
  static CUSTOMER_COUNTRY = 'CUSTOMER COUNTRY';
  static PREFERRED_CONTACT_CHANNEL = 'PREFERRED CONTACT CHANNEL';
  static WRITEUP_CUSTOMER_ACCEPTANCE = 'WRITE-UP CUSTOMER ACCEPTANCE';
  static RCF_APR = 'APR or RCF';
  static APR = 'APR';
  static RCF = 'RCF';
  static CASHDOWN = 'CASHDOWN';
  static CASHDOWN_APPLIED_TO_INCEPTION_FEES = 'CASHDOWN APPLIED TO INCEPTION FEES';
  static MILES_PER_YEAR = 'MILES PER YEAR';
  static MONTHLYPAYMENT = 'MONTHLYPAYMENT';
  static OFFERTYPE = 'OFFERTYPE';
  static RESIDUALVALUE = 'RESIDUALVALUE';
  static SECURITYDEPOSIT = 'SECURITYDEPOSIT';
  static CUSTOMER_CREDIT_SCORE = 'CUSTOMER CREDIT SCORE';
  static AMOUNT_DUE_AT_SIGNING = 'Amount Due At Signing';
  static INTEGRATE_TOTAL_OF_PAYMENTS: boolean = false; //if true - Total Of Payments will be visible.
  static TOTAL_AMOUNT_FINANCED = 'Total Amount Financed';
  static TOTAL_ESTIMATE_NET = 'Total Estimated Net Amount Due';
  static TERM_LENGTH = 'TERM_LENGTH';
  static VEHICLE_ID = 'VEHICLE ID';
  static VEHICLE_IMAGE_URL = 'VEHICLE IMAGE URL';
  static VEHICLE_JELLY_IMAGE_URL = 'Vehicle Jelly Image URL';
  static VEHICLE_SELLING_PRICE = 'VEHICLE SELLING PRICE';
  static CURRENT_ESTIMATE='Current Estimate';
  static EXTERIOR_COLOR_CODE = 'EXTERIOR COLOR CODE';
  static EXTERIOR_COLOR_HEX_CODE = 'EXTERIOR COLOR HEX CODE';
  static INTERIOR_COLOR_CODE = 'INTERIOR COLOR CODE';
  static INTERIOR_COLOR_SWATCH_URL = 'INTERIOR COLOR SWATCH URL';
  static MILEAGE = 'MILEAGE';
  static MILEAGE_AVERAGE = 'MILEAGE AVERAGE';
  static MILEAGE_CITY = 'MILEAGE CITY';
  static MILEAGE_HIGHWAY = 'MILEAGE HIGHWAY';
  static TRADED_VEHICLE_AVAILABILITY = 'TRADED VEHICLE AVAILABILITY';
  static TRADE_SOURCE = 'TRADE SOURCE';
  static TRADED_VEHICLE_1_ID = 'TRADED VEHICLE 1-ID';
  static TRADED_VEHICLE_1_VIN = 'TRADED VEHICLE 1-VIN';
  static TRADED_VEHICLE_1_MAKE = 'TRADED VEHICLE 1-MAKE';
  static TRADED_VEHICLE_1_MILEAGE = 'TRADED VEHICLE 1-MILEAGE';
  static TRADED_VEHICLE_1_SALES_ASSOCIATE_NOTES = 'TRADED VEHICLE 1-SALES ASSOCIATE NOTES';
  static TRADED_VEHICLE_1_PAYOFF = 'TRADED VEHICLE 1-PAYOFF';
  static TRADED_VEHICLE_1_TRADE_OFFER = 'TRADED VEHICLE 1-TRADE OFFER';
  static TRADED_VEHICLE_1_NET_TRADE_IN = 'TRADED VEHICLE 1-NET TRADE-IN';
  static TRADED_VEHICLE_2_ID = 'TRADED VEHICLE 2-ID';
  static TRADED_VEHICLE_2_VIN = 'TRADED VEHICLE 2-VIN';
  static TRADED_VEHICLE_2_MAKE = 'TRADED VEHICLE 2-MAKE';
  static TRADED_VEHICLE_2_MILEAGE = 'TRADED VEHICLE 2-MILEAGE';
  static TRADED_VEHICLE_2_SALES_ASSOCIATE_NOTES = 'TRADED VEHICLE 2-SALES ASSOCIATE NOTES';
  static TRADED_VEHICLE_2_PAYOFF = 'TRADED VEHICLE 2-PAYOFF';
  static TRADED_VEHICLE_2_TRADE_OFFER = 'TRADED VEHICLE 2-TRADE OFFER';
  static TRADED_VEHICLE_2_NET_TRADE_IN = 'TRADED VEHICLE 2-NET TRADE-IN';
  static TRADED_STATUS = 'TRADED STATUS';
  static DEAL_ID = 'DEAL ID';
  static PRICEEXPIRYDATE = 'PRICEEXPIRYDATE';
  static CHAR = 'char';
  static BOOLEAN = 'boolean';
  static STRING = 'string';
  static INTEGER = 'integer';
  static SELECT_FIELD = 'SELECT';
  static DATE_AND_TIME = 'DATE / TIME';
  static UNREAD = 'UNREAD';
  static YEAR = 'YEAR';
  static SERIES = 'SERIES';
  static EVENT = 'EVENT';
  static FAILURE = 'FAILURE';
  static ACTION = 'ACTION';
  static DEAL_STATUS = 'DEAL STATUS';
  static DATES_COLUMN = 'DATES';
  static DMS_RECORDS = 'DMS RECORDS';
  static PAYMENT_WITH_TAXES = 'PaymentWithTaxes';
  //start  for MSTM-39579
  static ONE_PAY_PAYMENT_WITH_TAXES = '1Pay_LeaseTotalCashPayment_WithTaxes'
  static ONE_PAY_PAYMENT_WITH_OUT_TAXES = '1Pay_LeaseTotalCashPayment_WithoutTaxes'
  static ONE_PAY_TOTALDUE_WITH_TAXES ='1Pay_TotalDueAtLeaseSigning_WithTaxes'
  static ONE_PAY_TOTALDUE_WITH_OUT_TAXES = '1Pay_TotalDueAtLeaseSigning_WithoutTaxes'
  //end for MSTM-39579
  static DISCLAIMERS = 'disclaimers';
  static DISCLOSURES = 'disclosures';
  static TOOL_DISCLAIMER = 'toolDisclaimer';
  static APR_DETAILS = 'aprDetails';
  static RATE_TERM_RETAIL = 'rateTermRetail';
  static LAST_MODIFIED_COLNAME = 'updatedDate.updatedDateAsDate';
  static NOTIFICATION_EVENTS = 'NotificationEvents';
  static NOTIFICATION_DETAILS = 'NotificationDetails';
  static MSRP_PRICE_LABEL = 'MSRP Price';
  static CAP_NONCAP_UNSAVED_MESSAGE = 'Your changes will not be saved.' +
  ' Do you want to continue?';
  static RATE_TERM_LEASE = "rateTermLease";
  static RATE_TERM_CASH = "rateTermCash";
  static RETAIL = "retail";
  static DEALER_COLUMN = 'DEALER #';
  static DEALER_NAME_COLUMN = 'DEALER NAME';
  static DEALER_ADDRESS_COLUMN = 'ADDRESS';
  static DEALER_CITY_COLUMN = 'CITY';
  static DEALER_STATE_COLUMN = 'STATE';
  static DEALER_ZIP_COLUMN = 'ZIP';
  static DEALER_PHONE_COLUMN = 'PHONE';
  static DEALER_BRAND_COLUMN = 'BRAND';
  static DEALER_AREAREGION_NUM_COLUMN = 'AREA/REGION #';
  static DEALER_AREAREGION_STRING_COLUMN = 'AREA/REGION';
  static DEALER_DISTRICT_COLUMN = 'DISTRICT #';
  static VEHICLE_PROMOTE_DESC_UPDATED_EVENT = 'vehicle-promote-desc-updated-event';
  static VEHICLE_PRICE_DISCLAIMERS_UPDATED_EVENT = 'vehicle-price-disclaimers-updated-event';
  static VEHICLE_DISCLAIMERS_UPDATED_EVENT = 'vehicle-disclaimers-updated-event';
  static DEMO = 'Demo';
  static DEALER_CATEGORY_L = 'L';
  static OFFER_LEAD = 'WRITE-UP/LEAD';
  static DEAL_ORIGIN = 'SOURCE/ORIGIN';
  static SELLING_PRICE_LABEL = 'SELLING PRICE($)';
  static SELLING_PRICE_WITHOUT_SYMBOL = 'Selling Price';
  static RTID = 'RTID';
  static DMS = 'DMS';
  static FLAG_Y = 'Y';
  static FLAG_N = 'N';
  static EN_US = 'en-US';
  static HASH = '#';
  static SAVE = 'save';
  static TEMP_SERIAL = 'TEMP SERIAL #';
  static REFRESH_TOKEN_INVOKED = 'refreshTokenInvoked';
  static REFRESH_TOKEN_TIME_PERIOD: number = 240 * 60 * 1000;
  static REFRESH_TOKEN_VERIFICATION_TIME_PERIOD: number = 245 * 60 * 1000;
  static LOGOUT_PERIOD: number = 8 * 60 * 60 * 1000;
  static DISCLAIMER_INDICATOR = 'DISC IND';
  static INSTALLED_PRICE = 'INSTALLED PRICE';
  static INSTALLED_PRICE_LABEL = 'Installed Price';
  static VEHICLE_PRICED_BUT_NOT_PROMOTABLE = `Vehicle is not promotable, prices are saved`;
  static PROMOTE_DISCLAIMER_MISSING = `Promote type disclaimer is mandatory`;
  static PROMOTABLE = 'PROMOTABLE';
  static MIN_ALLOWABLE_ADV_PRICE: number = 0.00;
  static LEAD_TYPE_VEHICLE_SELLING_PRICE = 'Vehicle Selling Price';
  static LEAD_TYPE_OFFER = 'Offer';
  static DEAL_TYPE_OFFER = 'Deal';
  static DEAL_TYPE_EQUITY = 'Equity';
  static DEAL_TYPE_CONFIRM_AVAILABILITY = 'ConfirmAvailability';
  static LEAD_TYPE_DEALER_CONTACT = 'Dealer Contact';  
  static MST_SELLING_PRICE = 'Selling Price';
  static SALES_MANAGER = 'SALES_MANAGER';
  static LEAD_TYPE_PAYMENT = 'Payment Estimate';
  static LEAD_TYPE_SHARED_SAVES = "Online Saves";
  static LEAD_TYPE_DEAL = "Deal";
  static PRICING="pricing";
  static DEALER ="dealer";
  static PAYMENT  ="paymentestimation";
  static SHAREDSAVE ="sharedsaves";
  static FEATURES: any = {
    GROUPPRICE: {
      NAME: 'GroupPrice',
      ATTRIBUTES: {
        MAXNUMBER: 'Max Number'
      }
    }
  };
  static ALL_ACTIVE_FEATURES = 'Import all active features';
  static LAST_MODIFIED_BY = 'LAST MODIFIED BY';
  static MONTLY_TERM_FINANCE = ['12', '24', '27', '36', '39', '48', '60', '63', '66', '72', '75', '84'];
  static MONTLY_TERM_LEASE = ['12', '24', '27', '36', '39', '48', '60'];
  static MONTHLY_TERM_LEASE_SET = ['24', '36', '39', '40', '42', '48', '51', '54', '60'];
  static ERROR_MSG_MONTHLY_TERM_FINANCE = 'Allowed Terms for Finance are: 12, 24, 27, 36, 39, 48, 60, 63, 66, 72, 75, 84';
  static ERROR_MSG_MONTHLY_TERM_LEASE = 'Allowed Terms for Lease are: 12, 24, 27, 36, 39, 48, 60';
  static ERROR_MSG_MONTHLY_TERM_LEASE_SET = 'Allowed Terms for Lease are: 24, 36, 39, 40, 42, 48, 51, 54, 60';
  static ERROR_MSG_DUPLICATE_TERM= 'Duplicate terms are not permitted.';
  static SELECT_TERM = 'selectedTerm';
  static DD_RTI_MST_CONSOLE = 'DD_RTI_MST_Console';
  static WRITE_UP_PRICIED = 'Write-up Priced';
  static EXPIRED = 'expired';
  static CANCELLED = 'cancelled';
  static EXPIRED_DATE = "Expired";
  static NOTIFY = 'notify';
  static CHAT = 'chat';
  static MESSAGE_SENT = 'MESSAGE SENT';
  static DEAL_NOTIFICATION_DIALOG_TITLE = 'WRITE-UP UPDATES';
  static CHAT_NOTIFICATION_DIALOG_TITLE = 'MESSAGES';
  static LEAD_LAST_MODIFIED_BY = "DG";
  static DEAL_STATUS_FINALIZED = "Finalized";
  static DEAL_STATUS_SENT_TO_FINANCE = "Sent to Finance";
  static DEAL_STATUS_FINALIZED_CAP = "FINALIZED";
  static DEAL_STATUS_DFI_SUBMITTED = "Dfi Submitted";
  static DEAL_STATUS_DFI_SUBMITTED_CAP = "DFI SUBMITTED";
  static DEAL_STATUS_CONTRACT_APPROVED = "Contract Approved";
  static RECORD_TYPE = "RECORD TYPE";
  static CUSTOMER_FIRST_NAME = "CUSTOMER FIRST NAME";
  static CUSTOMER_LAST_NAME = "CUSTOMER LAST NAME";
  static ORIGIN = "ORIGIN";
  static VEHICLE_MODEL_YEAR = "MODEL YEAR";
  static WRITEUP_EXPIRATION_DATE = "WRITE-UP EXPIRATION DATE";
  static WRITEUP_TYPE = "WRITE-UP TYPE";
  static CASH_DOWN_CASH = "CASH";
  static TOTAL_DOWN_PAYMENT = "Total Down Payment";
  static PRIOR_CREDIT_BALANCE = "PRIOR CREDIT BALANCE";
  static NET_CAPITALIZED_COST = "Net Capitalized Cost";
  static CAP_COST_REDUCTION = "CAP COST REDUCTION";
  static BASE_MONTHLY_PAYMENT = "BASE MONTHLY PAYMENT";
  static TRADE_IN_AMOUNT = "TRADE-IN AMOUNT";
  static OUTSTANDING_BALANCE_ON_TRADE = "OUTSTANDING BALANCE ON TRADE";
  static LEAD_ID = "LEAD ID";
  static LEAD_TYPE = "Lead Type";
  static OFFER_ID = "OFFER ID";
  static WRITEUP_STATUS = "WRITE-UP STATUS";
  static SALE_TYPE_COLUMN = "SALE TYPE";
  static VEHICLE_TYPE_NEW = 'new';
  static VEHICLE_TYPE_CERTIFIED = 'certified';
  static VEHICLE_TYPE_CPO = 'cpo';
  static VEHICLE_TYPE_USED = 'used';
  static OFFER_EXPIRATION = 'This Offer has expired.';
  static VEHICLE_EXPIRATION = 'This Vehicle is no longer available.';
  static ESTIMATE_EXPIRATION = 'This Estimate is no longer available.';
  static SALES_CONSULTANT = 'SALES CONSULTANT';
  static CURRENT_SALES_CONSULTANT = 'CURRENT SALES CONSULTANT';
  static ORIGINAL_SALES_CONSULTANT = 'ORIGINAL SALES CONSULTANT';
  static CURRENT_SERVICE_URL = "/offers/current?status=PENDING%20REVIEW,FINALIZED&visitedStatus=notVisited";
  static TOTAL_PURCHASE_PRICE = "Total Purchase Price";
  static TOTAL_VEHICLE_SELLING_PRICE = "Total Vehicle Selling Price";
  static PROCTECTION_PRODUCTS = "Protection Products";
  static PRODUCT_CHANGED = "PRODUCT_CHANGED";
  static PRODUCT_VISIBLE = "PRODUCT_VISIBLE";
  static PRODUCT_SELECTED = "PRODUCT_SELECTED";
  static STANDARD_EQUIPMENT = 'STANDARD EQUIPMENT';
  static SAFETY_AND_CONVENIENCE = 'SAFETY AND CONVENIENCE';
  static MECHANICAL_AND_PERFORMANCE = 'MECHANICAL AND PERFORMANCE';
  static INTERIOR = 'INTERIOR';
  static EXTERIOR = 'EXTERIOR';
  static OPTIONAL_EQUIPMENT = 'OPTIONAL EQUIPMENT';
  static DEAL_UPDATE = 'DEAL_UPDATE';
  static TMIS = 'TMIS';
  static NON_TMIS = 'nontmis';
  static GSFS = 'GSFS';
  static LEASE_VARIANT_1PAY = '1PAY';
  static OPTIONAL_TOYOTA_PRODUCTS = 'Optional Toyota Products';
  static OPTIONAL_NON_TOYOTA_PRODUCTS = 'Optional Non-Toyota Products';
  static OPTIONAL_LEXUS_PRODUCTS = 'Optional Lexus Products';
  static OPTIONAL_NON_LEXUS_PRODUCTS = 'Optional Non-Lexus Products';
  static OPTIONAL_TOYOTA_EXTRA_CARE_PRODUCTS = 'Optional Toyota Extra Care Products';
  static OPTIONAL_NON_TOYOTA_EXTRA_CARE_PRODUCTS = 'Optional Non-Toyota Extra Care Products';
   static OPTIONAL_FANDI_PRODUCTS = 'Optional F&I Products';
   static OTHER_DEALER_FANDI_PRODUCTS = 'Other Dealer F&I Products';
   static OPTIONAL_JMA_PRODUCTS = 'Optional Protection Products';
   static OPTIONAL_NON_JMA_PRODUCTS = 'Optional Other Protection Products';
  static PROVIDER = 'provider';
  static IS_CAPITALIZED = 'capitalized';
  static IS_TAXABLE = 'taxable';
  static PRODUCT_DESCRIPTION = 'productDescription';
  static PRODUCT_TERM = 'term';
  static PRODUCT_MILAGE = 'mileage';
  static PRODUCT_MAX_MONTHLY = 'maxMonthlyCovered';
  static DD_PAC_MANAGEMENT = 'DD_PAC_Management';
  static DD_PPM_PRESENTATION = 'DD_PPM_Presentation';
  static DD_TFS_FS_PRESENTATION = 'DD_TFS_FS_Presentation';
  static DD_FI_ADMINISTRATION = 'DD_FI_Administration';
  static DD_TFS_IRATEBOOK = 'DD_TFS_iRatebook';
  static DOFU_CHANGED = 'DOFU_CHANGED';
  static MSTC_CUSTOMER_INTERESTED_PROTECTION_PRODUCTS = 'Customer Interested';
  static CON = 'CON';
  static PROTECTION = 'protection';
  static OPTIONAL_FI_PRODUCTS = 'Optional F&I Products';
  static OTHER_DEALER_FI_PRODUCTS = 'Other Dealer F&I Products';
  static OPTIONAL_PROTECTION_PRODUCTS = 'Optional Protection Products';
  static DASHBOARD = 'DASHBOARD';
  static FILTERLABELDTAERANGE = 'Date Range';
  static FILTERLABELWRITEUPSTATUS = 'Write-Up Status';
  static FILTERLABELONLINESTATUS = 'Online Status';
  static FILTERLABELPURCHASETYPE = 'Purchase Type';
  static FILTERLABELSALETYPE = 'Sale Type';
  static FILTERLABELSALESTEAM = 'Sales Team';
  static webServiceTimeout = 30000;
  static timeoutErrorCode = 'timeout';
  static OFFERS_ = 'offers_';
  static STANDARD_LOWER='standard';
  static GOLD = 'Gold';
  static SILVER = 'Silver';
  static VehicleYEAR = 'year';
  static VehicleMAKE = 'make';
  static VehicleSERIES = 'series';
  static VehicleMODELTRIM = 'model trim';
  static VehicleSALESCLASS = 'sales class';
  static VehicleTYPE = 'vehicle type';
  static VehicleFUELTYPE = 'fuel type';
  static VehicleHORSEPOWER = 'horse power';
  static PAYMENT_ESTIMATE='Payment Estimate';
  static ONLINE_CREDIT_APPLICATION ='Online Credit Application';
  static CUSTOMER_VIEW ='cv/customer-view';
  static DFI = 'DFI';
  static Business_OCA = 'Business OCA';
  static Send_to_Deal_Jacket = 'Send to Deal Jacket';
  static Desk_Deal = 'Desk Deal';
  static FI_Admin_UI = 'FI Admin UI';
  static Desking = 'Desking';
  static Zero_Due_at_Signing = 'Zero Due at Signing';
  static First_Payment_Due_at_Signing = 'First Payment Due at Signing';
  static Payment_Grid_order = 'Payment Grid order';
  static Rebate_Capitalization = 'Rebate Capitalization';
  static Net_Trade_in_Capitalization = 'Net Trade-in Capitalization';
  static Cashdown_Capitalization = 'Cashdown Capitalization';
  static UVI_endpoint = 'UVI endpoint';
  static Smartpath_Dealer = 'Smartpath Dealer';
  static Residual_Override = 'Residual Override';
  static Lease_Variant = 'Lease Variant';
  static One_Pay_Lease = '1Pay Lease';
  static Enable_Share_Features = 'Enable Share Features';
  static OCA = 'OCA';
  static Special_Rate_Toggle = 'Special Rate Toggle';
  static Enable_Share_to_Online_Account = 'Enable Share to Online Account';
  static TCUV = 'TCUV';
  static Send_to_Transactions = 'Send to Transactions';
  static Lease_Mileage_New = 'Lease Mileage New';
  static Lease_Mileage_Certified = 'Lease Mileage Certified';
  static Low_Mileage_Lease = 'Low Mileage Lease';
  static NonToyotaProviderId = 'NonToyotaProviderId';
  static MST_FEATURES = 'MST-FEATURES';
  static Email = "Email";
  static Website = "Website";
  static Main_Dealer = "Main Dealer";
  static addressResultsCodes = {
    'AC01': 'The ZIP Code was changed or added.',
    'AC02': 'The State abbreviation was changed or added.',
    'AC03': 'The City name was changed or added.',
    'AC04': 'The USPS changed the address.',
    'AC05': 'The USPS changed the street name.',
    'AC06': 'Address1 and Address2 were swapped.',
    'AC07': 'Address1 and Company were swapped.',
    'AC08': 'The Plus 4 code was changed.',
    'AC09': 'The Puerto Rico Urbanization code was changed.',
    'AC10': 'The street name was changed.',
    'AC11': 'The street suffix abbreviation (st, rd, blvd) was changed.',
    'AC12': 'The street pre or post directional (n, sw, e) was changed.',
    'AC13': 'The suite or aparment name (apt, ste) was changed.',
    'AC14': 'The secondary unit number was changed or appended.',
    'AE01': 'The address could not be verified at least up to the postal code level.',
    'AE02': 'The street name was not found.',
    'AE03': 'Invalid Address Line 1. The suffix(AVE, ST, BLVD) is missing or invalid.',
    'AE04': 'The physical location exists but there are no addresses on this side of the street. Please provide a deliverable address.',
    'AE05': 'Multiple matching addresses found.',
    'AE07': 'The required combination of address/city/state or address/zip is missing.',
    'AE08': 'The suite or apartment number is not valid.',
    'AE09': 'The suite or apartment number is missing.',
    'AE10': 'The building or house number in the adress is not valid.',
    'AE11': 'The building or house number in the adress is missing.',
    'AE12': 'The input address box number is invalid.',
    'AE13': 'The input address box number is missing.',
    'AE15': 'Unable to perform address validation at this time. Try again later or contact staff master support.',
    'AE16': 'Unable to perform address validation at this time. Try again later or contact staff master support.',
    'AE17': 'Address does not have Suites or Apartments.',
    'AE18': 'Extra information found in address.',
    'AE19': 'Unable to perform address validation at this time. Try again later or contact staff master support.',
    'AE20': 'Unable to perform address validation at this time. Try again later or contact staff master support.',
    'AS02': 'The default building address was verified but the suite or apartment number is missing or invalid.',
    'AS09': 'Address in a non-supported country. (Should be handled as part of model validation)',
    'AS14': 'Appended a suite number using the address and company name.',
    'AS15': 'Appended an apartment number using the address and name.',
    'AS17': 'Address does not receive mail at this time. Please provide a deliverable address.',
    'AS18': 'Unable to perform address validation at this time. Try agin later or contact staff master support.'
  }
  static successResultsCodes = ['AE06', 'AE14', 'AS01', 'AS03', 'AS10', 'AS13', 'AS16', 'AS20', 'AS22', 'As23'];
  static fullStateNamesMappingArray = {
    'AL': 'ALABAMA', 'AK': 'ALASKA', 'AZ': 'ARIZONA', 'AR': 'ARKANSAS', 'CA': 'CALIFORNIA',
    'CO': 'COLORADO', 'CT': 'CONNECTICUT', 'DE': 'DELAWARE', 'DC': 'DISTRICT OF COLUMBIA', 'FL': 'FLORIDA', 'GA': 'GEORGIA', 'HI': 'HAWAII', 'ID': 'IDAHO', 'IL': 'ILLINOIS', 'IN': 'INDIANA', 'IA': 'IOWA',
    'KS': 'KANSAS', 'KY': 'KENTUCKY', 'LA': 'LOUISIANA', 'ME': 'MAINE', 'MD': 'MARYLAND',
    'MA': 'MASSACHUSETTS', 'MI': 'MICHIGAN', 'MN': 'MINNESOTA', 'MS': 'MISSISSIPPI',
    'MO': 'MISSOURI', 'MT': 'MONTANA', 'NE': 'NEBRASKA', 'NV': 'NEVADA', 'NH': 'NEW HAMPSHIRE',
    'NJ': 'NEW JERSEY', 'NM': 'NEW MEXICO', 'NY': 'NEW YORK', 'NC': 'NORTH CAROLINA',
    'ND': 'NORTH DAKOTA', 'OH': 'OHIO', 'OK': 'OKLAHOMA', 'OR': 'OREGON', 'PA': 'PENNSYLVANIA',
    'RI': 'RHODE ISLAND', 'SC': 'SOUTH CAROLINA', 'SD': 'SOUTH DAKOTA', 'TN': 'TENNESSEE',
    'TX': 'TEXAS', 'UT': 'UTAH', 'VT': 'VERMONT', 'VA': 'VIRGINIA', 'WA': 'WASHINGTON',
    'WV': 'WEST VIRGINIA', 'WI': 'WISCONSIN', 'WY': 'WYOMING'
  };
  static TABGRID='tabgrid';
  static TABSP='tabsp';
  static TABTRADE='tabtrade';
  static TABADDONS='tabaddOns';
  static TABPP='tabpp';
  static TABINCENTIVES='tabincentives';
  static TABCHAT='tabchat';
  static TABLOG='tablog';
  static TABTAXES='tabtaxes';
  static TAXES_FEES_ACCORDION_UP='taxesfeesaccordionup';
  static TAXES_FEES_ACCORDION_DOWN='taxeeesaccordiondown';
  static BUTTON_PRINT_PAYMENT='printPaymentButton';
  static BUTTON_EMAIL_PAYMENT='emailPaymentButton';
  static BUTTON_PRINT_SELECTION='paymentSelectionButton';
  static BUTTON_EMAIL_SELECTION='emailSelectionButton';
  static PRICEGRID_WAIVE_SLIDER='pricegridwaiveslider';
  static SILVER_CERTIFIED = "SILVER CERTIFIED";
  static GOLD_CERTIFIED = "GOLD CERTIFIED";
  static DEALER_RECOMMENDED = "Dealer Recommended Products";
}
